import { actionDescription } from '@captaincause/lib/impact/computeImpact'
import { formatNumber } from '@captaincause/lib/format'
import { tm } from '../../../tm'
import i18n from '../i18n'
import type { Locales, Project } from '@captaincause/types'

interface DoneProjectMessageProps {
  project: Project
  locale: Locales
  className?: string
}

export function DoneProjectMessage({
  project,
  locale,
  className = '',
}: DoneProjectMessageProps) {
  if (!project.is_done || !project.action) return null

  const t = i18n[locale]
  const baseImpactNumber = project.action.cumulated_num_items ?? 0
  const impactNumber =
    baseImpactNumber > 10
      ? Math.floor(baseImpactNumber)
      : Math.floor(baseImpactNumber * 10) / 10

  return (
    <div
      className={tm(
        'flex w-[90%] flex-col items-center justify-center gap-2 text-white',
        className,
      )}
    >
      <span className="text-sm font-medium leading-[18px] -tracking-[0.12px]">
        {t.thanks_to_you}
      </span>
      <span className="text-5xl font-extrabold leading-10">
        {formatNumber(impactNumber, locale)}
      </span>
      <span className="line-clamp-1 text-center text-sm font-medium leading-5 -tracking-[0.14px]">
        {actionDescription({
          action: project.action,
          length: 'long',
          numItems: project.action.cumulated_num_items,
        })}
      </span>
    </div>
  )
}
